module.exports = __webpack_public_path__ + "static/usluge_01-6b114d65562a7df3732a6ed5792c3538.jpg";